module.exports = __webpack_public_path__ + "static/media/logo.24563d67.png";